<template>
  <div>
    <v-card color="transparent" flat>
      <v-card-text
        ><h1>{{ title }}</h1></v-card-text
      >

      <v-card-text>
        <h3>Overview</h3>
        <slot name="overview">-- Your Overview Text Goes Here --</slot>
        <h3>Benefits</h3>
        <p><slot name="benefits">-- Your Benefit Text Goes Here --</slot></p>

        <br />
        <v-divider />
        <br />

        <slot></slot>
      </v-card-text>
    </v-card>

    <div v-if="youtubeLinks.length !== 0">
      <br />
      <h2>Video Tutorials</h2>
      <v-container fluid>
        <v-row>
          <v-col
            v-for="(link, l) in youtubeLinks"
            :key="`ref-link-${l}`"
            md="4"
            sm="6"
            cols="12"
          >
            <YoutubeVideo :title="link.title" :href="link.href"></YoutubeVideo>
          </v-col>
        </v-row>
      </v-container>
      <!-- <v-list-item>
        <v-list-item-content>
          <v-list-item-title>{{link.title}}</v-list-item-title>
          <v-list-item-subtitle><a :href="link.href" target="_blank">{{link.href}}</a></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action><v-btn :href="link.href" target="_blank" color="primary">Go</v-btn></v-list-item-action>
      </v-list-item>

      <v-divider /> -->

      <!-- </div> -->
      <br />
    </div>

    <v-card  v-if="referenceLinks.length !== 0">
      <v-card-title>References</v-card-title>

      <div v-for="(link, l) in referenceLinks" :key="`ref-link-${l}`">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ link.title }}</v-list-item-title>
            <v-list-item-subtitle
              ><a :href="link.href" target="_blank">{{
                link.href
              }}</a></v-list-item-subtitle
            >
          </v-list-item-content>
          <v-list-item-action
            ><v-btn :href="link.href" target="_blank" color="primary"
              >Go</v-btn
            ></v-list-item-action
          >
        </v-list-item>

        <v-divider />
      </div>
    </v-card>
  </div>
</template>

<script>
import YoutubeVideo from "../components/youtube-video";
export default {
  name: "TutorialLayout",
  components: { YoutubeVideo },
  props: {
    title: { type: String, default: "Untitled Tutorial" },
    referenceLinks: { type: Array, default: () => [] },
    youtubeLinks: { type: Array, default: () => [] },
  },
  computed: {},
};
</script>

<style lang="scss">
pre {
  display: flex;
  max-width: 100%;
  flex: 0 0 100%;
  code {
    padding: 30px !important;
    display: block !important;
    overflow: auto;
  }
}
</style>
